var searchPopup = $('#search-popup'),
		close = searchPopup.find('.close-popup');

const openModal = () => {
	$('.search__btn').on('click', () => {
		$('body').addClass('open-search');
	});
	$('.b-events__searchform input').on('focus', () => {
		$('body').addClass('open-search');
	});
}

const closeModal = () => {
	close.on('click', () => {
		$('body').removeClass('open-search');
	})
}

const searchProcess = () => {
	let form = $('#searchform');
	let resultEl = $('#search-results');
	let btn = form.find('button');

	form.on('submit', (e)=>{
		e.preventDefault();
		let data = form.serializeArray();

		resultEl.html('');
		btn.addClass('searching');

		$.post(themeData.url + 'paybis/v1/search/', data)
		.done( (response ) => {
				if( typeof response.html !== 'undefined' ) {
					resultEl.html(response.html);
				}
				else {
					resultEl.html('');
				}
				btn.removeClass('searching');
		});
	})
}

const init = () => {
	openModal();
	closeModal();
	searchProcess();
}

export default {
	init
}
